// @flow strict

import * as React from "react";
import { RegistroEquipo } from "~robin-hood/unregistered/RegistroEquipo";
import type { UnregisteredStore, Store } from "~robin-hood/redux/store";
import { UNREGISTERED_PATHS } from "~robin-hood/utils";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

type UnregisteredProps = {
  store: UnregisteredStore,
  updateStore: (Store) => void,
};

export function UnregisteredRobinHood(props: UnregisteredProps): React$Node {
  const { store, updateStore } = props;
  return (
    <Router>
      <Switch>
        <Route
          exact
          path={UNREGISTERED_PATHS.HOME()}
          render={({ history }) => (
            <RegistroEquipo
              history={history}
              store={store}
              updateStore={updateStore}
            />
          )}
        />
        <Route render={() => <Redirect to={UNREGISTERED_PATHS.HOME()} />} />
      </Switch>
    </Router>
  );
}
